import { render, staticRenderFns } from "./AntrfileWithLinkEl.vue?vue&type=template&id=23105188&scoped=true&"
import script from "./AntrfileWithLinkEl.vue?vue&type=script&lang=ts&"
export * from "./AntrfileWithLinkEl.vue?vue&type=script&lang=ts&"
import style0 from "./AntrfileWithLinkEl.vue?vue&type=style&index=0&id=23105188&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23105188",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VSheet})
